<template>
    <v-overlay :value="loading">
        <Spinner size="huge" line-fg-color="#204281"/>
    </v-overlay>
</template>

<script>
import Spinner from 'vue-simple-spinner'

export default {

    components: {
        Spinner
    },
    //loading is a variable (set in the parent component that uses this component) that toggles display of the overlay when set to true/false.
    props: ['loading'],
    
}
</script>

<style scoped>



</style>